var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaGrainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 41.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #13100d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.78,19.55v-3.84h9.77v9.49c-1.1,1.42-2.5,2.53-4.21,3.32-1.71.79-3.62,1.18-5.72,1.18-2.26,0-4.32-.55-6.18-1.65-1.86-1.1-3.32-2.6-4.37-4.5-1.06-1.9-1.59-4-1.59-6.3s.53-4.38,1.58-6.25c1.05-1.87,2.5-3.35,4.36-4.42,1.85-1.07,3.91-1.6,6.17-1.6,2.37,0,4.5.55,6.37,1.66,1.87,1.11,3.13,2.55,3.77,4.32l-3.58,1.76c-.54-1.16-1.39-2.09-2.56-2.79-1.17-.69-2.5-1.04-4-1.04-2.32,0-4.22.78-5.71,2.34-1.49,1.56-2.23,3.57-2.23,6.02s.75,4.53,2.26,6.14c1.51,1.61,3.41,2.42,5.72,2.42s4.39-.65,5.91-1.96v-4.3h-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.39,12.23c.77,0,1.42.09,1.93.27l-.23,3.61c-.65-.22-1.32-.33-2-.33s-1.43.26-2.2.78c-.77.52-1.37,1.22-1.8,2.11v10.73h-3.81V12.58h3.81v2.3c.41-.78,1.04-1.42,1.86-1.91.83-.49,1.64-.74,2.43-.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.66,12.58h3.83v16.81h-3.83v-2.27c-.45.76-1.17,1.39-2.17,1.87s-2.06.73-3.18.73c-2.26,0-4.17-.85-5.73-2.54-1.56-1.69-2.34-3.77-2.34-6.23s.78-4.5,2.34-6.19c1.56-1.69,3.47-2.54,5.73-2.54,1.11,0,2.17.25,3.17.74,1.01.49,1.73,1.12,2.18,1.88v-2.27ZM103.09,26.08c.94,0,1.83-.23,2.68-.7.84-.47,1.47-1.07,1.89-1.8v-5.15c-.41-.75-1.04-1.36-1.88-1.84-.84-.48-1.74-.71-2.69-.71-1.44,0-2.65.48-3.63,1.45-.97.97-1.46,2.18-1.46,3.63s.49,2.67,1.46,3.65c.97.98,2.18,1.47,3.63,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.22,12.58h3.81v16.81h-3.81V12.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.85,12.23c2.1,0,3.78.68,5.02,2.05,1.24,1.37,1.86,3.21,1.86,5.52v9.59h-3.84v-8.98c0-1.34-.36-2.41-1.08-3.19-.72-.78-1.68-1.17-2.88-1.17-.86,0-1.68.21-2.44.64-.77.43-1.36,1-1.79,1.71v11h-3.81V12.58h3.81v2.27c.51-.81,1.24-1.44,2.17-1.91.93-.47,1.93-.71,2.99-.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.8,34.34c.45-.46,1-.68,1.63-.68s1.18.23,1.64.68c.46.46.69,1,.69,1.62s-.23,1.2-.69,1.65c-.46.46-1.01.68-1.64.68s-1.18-.23-1.63-.68-.68-1.01-.68-1.65.23-1.17.68-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.82,34.34c.45-.46,1-.68,1.63-.68s1.18.23,1.64.68c.46.46.69,1,.69,1.62s-.23,1.2-.69,1.65c-.46.46-1.01.68-1.64.68s-1.18-.23-1.63-.68-.68-1.01-.68-1.65.23-1.17.68-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.82,4.33c.45-.46,1-.68,1.63-.68s1.18.23,1.64.68c.46.46.69,1,.69,1.62s-.23,1.2-.69,1.65c-.46.46-1.01.68-1.64.68s-1.18-.23-1.63-.68-.68-1.01-.68-1.65.23-1.17.68-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.8,4.33c.45-.46,1-.68,1.63-.68s1.18.23,1.64.68c.46.46.69,1,.69,1.62s-.23,1.2-.69,1.65c-.46.46-1.01.68-1.64.68s-1.18-.23-1.63-.68-.68-1.01-.68-1.65.23-1.17.68-1.62Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.57,
    y: 17.9,
    width: 4.64,
    height: 18.32,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-14.78 18.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.09,
    y: 34.75,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-19.55 29.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.06,
    y: 11.73,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-10.01 6.95) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 5.74,
    width: 4.64,
    height: 18.32,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-2.61 23.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.26,
    y: 22.58,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-7.37 35.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.23,
    y: -0.44,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(2.16 11.99) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.77,
    y: 17.93,
    width: 4.64,
    height: 18.32,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-11.22 27.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.28,
    y: 34.78,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-15.99 38.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.26,
    y: 11.75,
    width: 4.64,
    height: 7.65,
    rx: 2.32,
    ry: 2.32,
    transform: "translate(-6.45 15.58) rotate(-45)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaGrainLogo);
export default __webpack_public_path__ + "static/media/SPA_grain_logo.6488e86d070ff7ffaf0bcb82445e3934.svg";
export { ForwardRef as ReactComponent };